var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1059_11126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 8.59995C12.667 6.90257 13.3413 5.2747 14.5415 4.07447C15.7417 2.87423 17.3696 2.19995 19.067 2.19995C20.7644 2.19995 22.3922 2.87423 23.5925 4.07447C24.7927 5.2747 25.467 6.90257 25.467 8.59995C25.467 10.2973 24.7927 11.9252 23.5925 13.1254C22.3922 14.3257 20.7644 15 19.067 15C17.3696 15 15.7417 14.3257 14.5415 13.1254C13.3413 11.9252 12.667 10.2973 12.667 8.59995ZM12.667 18.2C10.5453 18.2 8.51043 19.0428 7.01014 20.5431C5.50985 22.0434 4.66699 24.0782 4.66699 26.2C4.66699 27.473 5.17271 28.6939 6.07288 29.5941C6.97305 30.4942 8.19395 31 9.46699 31H28.667C29.94 31 31.1609 30.4942 32.0611 29.5941C32.9613 28.6939 33.467 27.473 33.467 26.2C33.467 24.0782 32.6241 22.0434 31.1238 20.5431C29.6236 19.0428 27.5887 18.2 25.467 18.2H12.667Z",
    fill: "#99D6A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.167 8.59995C13.167 7.03517 13.7886 5.53449 14.8951 4.42802C16.0015 3.32156 17.5022 2.69995 19.067 2.69995C20.6318 2.69995 22.1325 3.32156 23.2389 4.42802C24.3454 5.53449 24.967 7.03517 24.967 8.59995C24.967 10.1647 24.3454 11.6654 23.2389 12.7719C22.1325 13.8783 20.6318 14.5 19.067 14.5C17.5022 14.5 16.0015 13.8783 14.8951 12.7719C13.7886 11.6654 13.167 10.1647 13.167 8.59995ZM7.36369 20.8967C8.77021 19.4901 10.6779 18.7 12.667 18.7H25.467C27.4561 18.7 29.3638 19.4901 30.7703 20.8967C32.1768 22.3032 32.967 24.2108 32.967 26.2C32.967 27.3404 32.514 28.4341 31.7076 29.2405C30.9011 30.0469 29.8074 30.5 28.667 30.5H9.46699C8.32656 30.5 7.23284 30.0469 6.42643 29.2405C5.62003 28.4341 5.16699 27.3404 5.16699 26.2C5.16699 24.2108 5.95717 22.3032 7.36369 20.8967Z",
    stroke: "#3AB54A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1059_11126",
    x: 0.666992,
    y: 0.199951,
    width: 36.7998,
    height: 36.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1059_11126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1059_11126",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayment);
export default __webpack_public_path__ + "static/media/ic-payment.3a66d4dc2c934e69d93231b87ab68c56.svg";
export { ForwardRef as ReactComponent };